// extracted by mini-css-extract-plugin
module.exports = {"customHead":"index_customHead_2lemL","customTitle":"index_customTitle_2Gmp4","customLeft":"index_customLeft_2GDPA","totalTip":"index_totalTip_2eIPl"};